import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-play-circle-fill text-xl" />
            </span>
            <span className="font-brand text-xl text-background-50">{site.shortName}</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">
            {site.description}
          </p>
          <p className="mt-4 text-xs leading-relaxed text-primary-200/70">
            本站为影视资源展示演示站点，播放区域仅为界面演示，暂未接入真实播放接口，所有内容仅供学习与交流使用。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-background-50">浏览分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/category/drama" className="text-primary-100/80 transition-colors hover:text-accent-400">
                日韩电视剧
              </Link>
            </li>
            <li>
              <Link to="/category/movie" className="text-primary-100/80 transition-colors hover:text-accent-400">
                日韩电影
              </Link>
            </li>
            <li>
              <Link to="/search" className="text-primary-100/80 transition-colors hover:text-accent-400">
                全站搜索
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-medium text-background-50">关于本站</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-primary-100/80 transition-colors hover:text-accent-400">
                站点介绍
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-primary-100/80 transition-colors hover:text-accent-400">
                免责声明
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-primary-100/80 transition-colors hover:text-accent-400">
                联系我们
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800/60">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-primary-200/70 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <span>© {year} {site.name}. 保留所有权利。</span>
          <span>中文字幕 · 日韩影视 · 在线观看</span>
        </div>
      </div>
    </footer>
  );
}